import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './Savings.messages';
import styles from './Savings.module.css';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const Savings = ({
    totalSaving,
    isLoading
}: {
    totalSaving: number;
    isLoading: boolean;
}) => {
    return (
        <SummaryRow isLoading={isLoading}>
            <div />
            <div
                className={classnames(styles.savesMe, {
                    [styles.loading]: isLoading
                })}
            >
                <FormattedMessage {...messages.thisSavesMe} />
                <span data-testid="early-repayment-interest-savings">
                    <MoneyWithDecimals value={totalSaving} />
                </span>
            </div>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default Savings;
